import { render, staticRenderFns } from "./Jkfill.vue?vue&type=template&id=b82d4554&scoped=true&"
import script from "./Jkfill.vue?vue&type=script&lang=js&"
export * from "./Jkfill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d4554",
  null
  
)

export default component.exports